<div class="container-scroller">
  <app-header (superMaduleEvent)="changeRole($event)"></app-header>
  <div class="body-wrapper">
    <app-sidebar [sMaduleId]="sMaduleId"></app-sidebar>
    <router-outlet></router-outlet>
  </div>
</div>
